<template>
  <div class="overlay">
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ t("ZENDESK_HELP_PAGE_TITLE") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-data">
              <p class="modal-data-key">{{ t("ZENDESK_HELP_PAGE_EMAIL") }}</p>
              <div class="modal-data-value">
                <p class="modal-data-email-text">mxpayjoymerchant@mail.com</p>
              </div>
            </div>
            <div class="modal-data">
              <p class="modal-data-key">
                {{ t("ZENDESK_HELP_PAGE_PASSWORD") }}
              </p>
              <div class="modal-data-value">
                <p class="modal-data-password-text">Acces0PJ$</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="pj-green-btn" @click="goToZendeskHelpPage">
              {{ t("ZENDESK_HELP_PAGE_BUTTON") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import logEvent from "@/apps/merchant3/services/event-logs.service";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import { useI18n } from "@/apps/merchant3/composables/useI18n";

const { t } = useI18n();

const emit = defineEmits(["close"]);

const closeModal = () => {
  emit("close");
};

const goToZendeskHelpPage = () => {
  logEvent(EventLogs.Events.ZENDESK_HELP_PAGE_BUTTON_CLICKED);
  window.open("https://payjoy.zendesk.com/hc/es", "_blank");
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(151, 151, 151, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  z-index: 2;
}

.modal {
  display: block;
}

.modal-header .close {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
}

.modal-header .close span {
  font-size: 1.5rem;
}

.modal-title {
  font-size: 16px;
}

.modal-body {
  text-align: left;
  display: flex;
  flex-direction: column;
}

.modal-footer {
  border-top: none;
}

.modal-data {
  display: flex;
  align-items: center;
  height: 47px;
  margin-bottom: 10px;
}

.modal-data-key {
  width: 80px;
}

.modal-data-value {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  width: 410px;
  height: 40px;
  background-color: $pj-color-lighter-gray;
  border-radius: 10px;
  text-align: center;
}

.pj-green-btn {
  text-align: center;
  margin-top: 5px;
  width: calc(100% - 1rem);
  margin-left: auto;
  margin-right: auto;
}

p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
